import { validateTitle, validateDescription } from '../validations/issue';

export const getEmptyInputsErrorsObject = (inputsObject) => {
	let errorsObject = {};
	Object.keys(inputsObject).forEach((key) => {
		const value = inputsObject[key];
		if (!value) {
			if (key === 'Title') {
				const { error } = validateTitle({ value });
				errorsObject = { ...errorsObject, Title: error };
			} else if (key === 'Description') {
				const { error } = validateDescription({ value });
				errorsObject = { ...errorsObject, Description: error };
			}
		}
	});
	return errorsObject;
};
